import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoReplaceRefresh = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>ReplaceRefresh</title>
    <path
      d="M6.332 13.403c5.249-8.589 15.11-8.907 19.979-2.34m-20.6-4.6.038 7.404 7.404-.037m14.51 6.738c-5.249 8.588-15.11 8.906-19.98 2.34m20.6 4.6-.037-7.404-7.404.036"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoReplaceRefresh;
